<template>
  <component id="app" v-bind:is="layout" :class="layoutClass">
    <router-view />
  </component>
</template>

<script>
export default {
  name: "app",

  computed: {
    loggedIn() {
      return this.$store.getters["authentication/loggedIn"];
    },
    layout() {
      if (this.$route.name == "login") {
        return "layout-guest";
      }
      return "layout-dashboard";
    },
    layoutClass() {
      return this.layout == "layout-dashboard" ? "restricted" : "public";
    }
  },

  components: {
    "layout-dashboard": () =>
      import(/* webpackChunkName: "layout-dashboard" */ "./layouts/dashboard"),
    "layout-guest": () =>
      import(/* webpackChunkName: "layout-guest" */ "./layouts/guest")
  }
};
</script>

<style lang="scss">
// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
// @import "~normalize.css/normalize.css";

// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import "~nprogress/nprogress.css";

// Imported globally in vue.config.js
// Bulma's core
// @import "~bulma/sass/utilities/_all";
// Custom Variables
// @import "styles/_variables.scss"; // Set your colors

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// Fonts
@import "assets/fonts/ibranch/style.css";
// @import "assets/fonts/eina/style.css";

/* SAPP FONT */
.ibranchfont,
.ibranchfont:before {
  display: inline-block;
}
.ibranchfont {
  vertical-align: top;
}
.ibranchfont.ibranchfont-fw {
  width: 1em;
  text-align: center;
}

input.input-is-fat {
  padding: 1.5rem 1rem;
}
input.input-is-dark {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
input.input-is-dark::placeholder {
  color: #fff;
  opacity: 0.75;
}

.modal-card {
  padding: 1rem;
}

/* VIEW */
@media only screen {
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // font-family: "Eina", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
  }

  html,
  body {
    // background-color: #fff;
    background-color: $body-background-light;
  }

  html,
  body,
  #app {
    position: relative;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    user-select: none;
  }

  #app,
  #app__view,
  .view,
  .view__body {
    display: flex;
    flex-direction: column;
  }

  #app__view,
  .view,
  .view__body {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    scroll-behavior: smooth;
    will-change: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .view__head,
  .view__body {
    padding: 1rem;
    width: 100%;
  }

  .view__body {
    padding: $column-gap * 2;
  }

  .view__head {
    position: relative;
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:not(:last-child) {
        margin-bottom: $column-gap;
      }
      .rowColumn {
        display: flex;
        align-items: center;
        &.grow {
          flex: 1 0 0;
        }
      }
    }
    .container {
      .columns {
        justify-content: space-between;
      }
      .column {
        display: flex;
        align-items: center;
      }
    }
    .app-back {
      display: inline-block;
      margin-right: 2rem;
    }
    .bar__title,
    .title {
      color: #2b3044;
      font-weight: bold;
      font-size: 1.375rem;
      margin-bottom: 0;
    }
  }
}
</style>
